import { Space } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { useAuth } from "src/core/hooks/useAuth";
import { costByFatherService } from "src/core/services/costExplosionServices/costByFatherService";
import { useFatherCodeDataItemColumns } from "src/modules/CostExplosionManager/tabs/CostByFatherTab/components/FatherCodeTable/hooks/useFatherCodeDataItemColumns";
import { useCostByFatherDataItemData } from "src/modules/CostExplosionManager/tabs/CostByFatherTab/hooks/useCostByFatherDataItemData";
import { TableColumnsSelector } from "src/modules/TableColumnsSelector/TableColumnsSelector";
import {
  costExplosionAppState,
  costExplosionGlobalState,
} from "src/recoil/costExplosionAtoms";
import { tableWidthSelector } from "src/recoil/selectors";
import { CostByFatherDataItem } from "src/types/costExplosion";

export const FatherCodeTable: React.FC = () => {
  const [tableLoading, setTableLoading] = useState(false);

  const { accessToken, success, authLoaded } = useAuth();

  const [dataItems, setDataItems] = useState<CostByFatherDataItem[]>([]);

  const tableWidth = useRecoilValue(tableWidthSelector);

  const costExplosionAppStateData = useRecoilValue(costExplosionAppState);

  const costExplosionState = useRecoilValue(costExplosionGlobalState);

  const { processed, processedData } = useCostByFatherDataItemData(dataItems);
  const { getTableColumns } = useFatherCodeDataItemColumns(processedData);

  const [tableColumns, setTableColumns] = useState<
    ColumnsType<CostByFatherDataItem>
  >([]);
  const [filteredTableColumns, setFilteredTableColumns] = useState<
    ColumnsType<CostByFatherDataItem>
  >([]);

  useEffect(() => {
    (async () => {
      setTableColumns(getTableColumns());
      setFilteredTableColumns(getTableColumns());
    })();
  }, [getTableColumns]);

  useEffect(() => {
    (async () => {
      if (authLoaded && success) {
        if (!costExplosionAppStateData.selectingModelSku) {
          if (
            costExplosionState.selectedModelSkus &&
            costExplosionState.selectedModelSkus?.length > 0
          ) {
            setTableLoading(true);

            let skusList: string[] = [];

            costExplosionState.selectedModelSkus.forEach((m) => {
              if (m.sku) {
                skusList.push(m.sku);
              }
            });

            if (skusList.length > 0) {
              const response =
                await costByFatherService.fetchFatherCodeDataItems(
                  accessToken,
                  costExplosionState.modelNumber ?? "",
                  skusList,
                  costExplosionState.adjustmentsEnabled
                );

              setDataItems(response);
            }

            setTableLoading(false);
          }
        }
      }
    })();
  }, [
    accessToken,
    authLoaded,
    costExplosionAppStateData.selectingModelSku,
    costExplosionState.adjustmentsEnabled,
    costExplosionState.modelNumber,
    costExplosionState.selectedModelSkus,
    success,
  ]);

  return (
    <Space direction="vertical" size={20} style={{ width: "100%" }}>
      <TableColumnsSelector
        baseColumns={tableColumns as []}
        setTableColumns={(columnsList) => {
          setFilteredTableColumns(
            columnsList as ColumnsType<CostByFatherDataItem>
          );
        }}
        unselectedColumnKeys={[
          "dm_column",
          "dl_column",
          "sc_column",
          "fov_column",
          "fof1_column",
          "fof2_column",
          "mo_column",
          "dc_column",
        ]}
      />
      <Table
        columns={filteredTableColumns}
        loading={tableLoading || !processed}
        dataSource={processedData}
        pagination={false}
        rowKey={({ rowKey }) => `${rowKey}`}
        sticky={true}
        scroll={{ x: "max-content", y: 480 }}
        style={{ width: tableWidth }}
        rowClassName={(row) =>
          (row.rowType ?? null) !== null ? `row-type-class-${row.rowType}` : ""
        }
        size={"small"}
        bordered
      />
    </Space>
  );
};
